/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 1 = %

2 = $

3 = C/P

4 = $/unit

5 = Margin


 */
export type MarkupColumnTypes =
  (typeof MarkupColumnTypes)[keyof typeof MarkupColumnTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarkupColumnTypes = {
  Percentage: 1,
  Price: 2,
  OwnerPrice: 3,
  UnitPrice: 4,
  Margin: 5,
} as const;
